define("@latermedia/ember-later-analytics/utils/state-types/loading", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  /**
   * @module Utils
   */

  /**
   * @class LoadingUtil
   * @extends Utils
   */

  /**
   * Loading State
   *
   * @property LOADING
   * @returns {string}
   */
  const LOADING = 'loading';
  var _default = _exports.default = LOADING;
});